import i18n from '@/plugins/i18n';
import ModuleService from '@/services/API/ModuleService';
import { MODULE_STATUSES } from '@/modules/Modules/constants';

import Base from '../Base';

export default class Module extends Base {
  constructor(item) {
    super(item.id, '/course-modules');
    this.name = item.name;
    this.description = item.description;
    this.direction = item.direction;
    this.type = item.type;
    this.status = item.status;
    this.price_per_user = item.price_per_user;
    this.price_escort_per_user = item.price_escort_per_user;
    this.is_pricing = item.is_pricing;
    this.is_escorted = item.is_escorted;
    this.user_special_conditions = item.user_special_conditions;
    this.max_age = item.max_age;
    this.min_age = item.min_age;

    // expand
    this.course_units_count = item.course_units_count || 0;
    this.accepted_users_count = item.accepted_users_count || 0;
    this.courses = item.courses || [];
    this.course_units = item.course_units || [];
    this.prior_records = item.prior_records;
    this.prior_records_exists = item.prior_records_exists;
    this.user_status = item.user_status; // 1 - not active 2 - active 3 - deactivated 4 - banned
    this.organization_special_conditions = item.organization_special_conditions;
    this.telegram = item.telegram;
  }

  get ageDistanceString() {
    if (!this.min_age) return 'Без ограничений по возрасту';
    return `от ${this.min_age} до ${i18n.tc('years', this.max_age)}`;
  }

  get isPublished() {
    return this.status === MODULE_STATUSES.active;
  }

  clone() {
    return ModuleService.clone(this.id);
  }

  attach(courseId) {
    return ModuleService.attach(this.id, {
      course_id: courseId,
    });
  }
}
